import * as Actions from '@/redux/actions';
import * as Constants from '@/redux/constants';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@mui/material';
import { useDialogs } from '@toolpad/core';
import { useDispatch, useLocale, useSelector } from 'hooks';
import { useI18n } from 'locales';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useEffect, useState, useCallback } from 'react';
import { shallowEqual } from 'react-redux';

const selector = (state) => ({
  recurringGivingInfo: state.recurringGivingInfo,
});

function PaymentModal({ open, onClose, data }) {
  const t = useI18n();
  const locale = useLocale();
  const dispatch = useDispatch();
  const dialogs = useDialogs();
  const { recurringGivingInfo } = useSelector(selector, shallowEqual);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const transactionId = get(data, 'onlinePayment.transactionId');
    const paymentIntentId = get(data, 'onlinePayment.paymentIntentId');
    // const amount = get(data, 'amount');

    if (!open || !transactionId || !paymentIntentId) {
      setIsFetching(false);
      return;
    }

    if (!window.qfpay || typeof window.qfpay.payment !== 'function' || typeof window.qfpay.element !== 'function') {
      setIsFetching(false);
      return;
    }

    let lang = 'en';
    switch (locale) {
      case 'zh-Hant':
        lang = 'zh-hk';
        break;
      case 'zh-Hans':
        lang = 'zh-cn';
        break;
      default:
        lang = 'en';
        break;
    }

    const payment = window.qfpay.payment();

    payment.pay({
      goods_name: (get(data, 'type') + ' Giving').trim(),
      paysource: 'payment_element',
      customer_id: get(data, 'qfpayCustomerId'),
      // token_expiry: moment(get(data, 'onlinePayment.paymentIntentExpiresAt')).tz('Asia/Hong_Kong').format('YYYY-MM-DD HH:mm:ss'),
      token_reason: 'recurring_giving',
      token_reference: transactionId,
    }, paymentIntentId);
    // payment.walletPay({
    //   lang,
    //   goods_name: (get(data, 'type') + ' Giving').trim(),
    //   paysource: 'payment_element',
    //   out_trade_no: transactionId,
    //   // txamt: amount * 100,
    //   // txcurrcd: 'HKD',
    //   customer_id: get(data, 'qfpayCustomerId'),
    //   token_expiry: moment(get(data, 'onlinePayment.paymentIntentExpiresAt')).tz('Asia/Hong_Kong').format('YYYY-MM-DD HH:mm:ss'),
    //   token_reason: 'recurring_giving',
    //   token_reference: transactionId,
    // }, paymentIntentId);

    const elements = window.qfpay.element({
      billingAddressDisplay: {
        city: false,
        address1: false,
        address2: false,
      },
    });

    elements.createEnhance({
      selector: '#_payment-modal',
      lang,
    });

    // elements.createWallet({
    //   selector: '#_payment-modal',
    //   lang,
    // });

    // window.qfpay.confirmPayment({
    //   // return_uri: null,
    // }).then((paymentResponse) => {
    //   dispatch(Actions.updateRecurringGiving({
    //     payload: {
    //       id: get(data, 'id'),
    //       locale,
    //       ...paymentResponse,
    //     },
    //   }));
    // });
  }, [open, data, locale]);

  useEffect(() => {
    switch (recurringGivingInfo.type) {
      case Constants.UPDATE_RECURRING_GIVING.SUCCESS: {
        location.href = get(recurringGivingInfo, 'data.redirectUrl');
        break;
      }
      case Constants.UPDATE_RECURRING_GIVING.FAILURE: {
        break;
      }
    }
  }, [recurringGivingInfo]);

  const onConfirm = useCallback(() => {
    setIsFetching(true);

    window.qfpay.confirmPayment({
      // return_uri: null,
    }).then((paymentResponse) => {
      if (paymentResponse?.code === '0000') {
        dispatch(Actions.updateRecurringGiving({
          payload: {
            id: get(data, 'id'),
            locale,
            ...paymentResponse,
          },
        }));
      } else {
        dialogs.alert(
          get(paymentResponse, 'description', t('An error occurred during payment. Please try again.')),
          { title: t('Payment Failed'), okText: 'OK' }
        );
        setIsFetching(false);
      }
    });
  }, [data, locale, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog
      open={open}
      onClose={isFetching ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      keepMounted
    >
      <DialogTitle>
        {t('Complete Payment')}
      </DialogTitle>
      <DialogContent>
        <div id="_payment-modal" />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="large"
          type="submit"
          fullWidth
          sx={{
            backgroundColor: 'primary.main',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '1rem',
            px: 4,
            py: 1.5,
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: 'primary.dark'
            }
          }}
          disabled={recurringGivingInfo.isFetching || isFetching}
          onClick={onConfirm}
        >
          {t('Confirm Payment')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PaymentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object,
};

export default PaymentModal;
